<style scoped lang="less">
  .form-card {
    background: #fff;
    margin-bottom: 24px;
    &-title {
      height: 55px;
      line-height: 55px;
      padding-left: 32px;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.85);
      border-bottom: 1px solid #e9e9e9;
    }
    &-content {
      padding: 24px;
    }
  }
  .pagination {
    margin-top: 20px;
    text-align: center;
  }
  .form-bottom-tool {
    padding: 16px 32px;
    background: #fff;
    border-top: 1px solid #E8E8E8;
  }
</style>
<template>
  <div>
    <Form ref="formValidate" :model="form" :rules="ruleValidate" :label-width="80" style="width:100%;padding:24px;">
      <div class="form-card">
        <div class="form-card-title">目标文件</div>
        <div class="form-card-content">
          <FormItem v-for="(item,index) in form.urls"
                    :key="item.key"
                    :label="index==0?'URL':''"
                    :prop="'urls[' + index + '].value'"
          >
            <Row>
              <Col span="18">
                <Input v-model="form.urls[index].value" placeholder="请输入目标文件地址"/>
              </Col>
              <Col span="4">
                &nbsp;&nbsp;
                <Icon type="plus-round" @click="handleAddUrl()"/>&nbsp;&nbsp;
                <Icon type="minus-round" @click="handleRemoveUrl(index)" v-if="form.urls.length>1"/>
              </Col>
            </Row>
          </FormItem>
          <FormItem label="上传" prop="uploads">
            <Upload :action="uploadUrl" :on-success="handleUploadSuccess" :on-remove="handleUploadRemove">
              <Button type="ghost" icon="ios-cloud-upload-outline">上传</Button>
            </Upload>
          </FormItem>
        </div>
      </div>
      <div class="form-card">
        <div class="form-card-title">选择模板</div>
        <div class="form-card-content">
          <Row :gutter="10">
            <Col span="6">
              <FormItem label="名称" placeholder="模板名称" >
                <Input v-model="params.name" @on-keyup="fetch"/>
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem label="宽度">
                <Input v-model="params.width" @on-keyup="fetch"/>
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem label="高度">
                <Input v-model="params.height" @on-keyup="fetch"/>
              </FormItem>
            </Col>
            <Col span="6">
              <FormItem label="导出大小">
                <Input v-model="params.fileSize" @on-keyup="fetch"/>
              </FormItem>
            </Col>
          </Row>
          <Table highlight-row :columns="columns" :data="data" @on-current-change="handleSelectTemplate"></Table>
          <div class="pagination">
            <Page :current="currentPage" :total="total" @on-change="onChangePage"></Page>
          </div>
        </div>
      </div>
      <div class="form-card">
        <div class="form-card-title">输出设置</div>
        <div class="form-card-content">
          <FormItem label="任务名称" prop="name">
            <Input v-model="form.name" placeholder="任务名称" style="width: 250px"/>
          </FormItem>
        </div>
      </div>
    </Form>
    <div class="form-bottom-tool">
      <Button type="primary" @click="submitForm">提交</Button>
    </div>
  </div>
</template>
<script>
  import {
    UPLOAD_URL,
    CREATE_TASK,
    GET_TEMPLATE_LIST
  } from '@/utils/api';
  import _ from 'lodash'
  import pagination from '@/mixins/pagination'

  export default {
    mixins:[pagination],
    data() {
      return {
        data: [],
        form: {
          urls: [
            {
              value: '',
              index: +new Date()
            }
          ],
          name:'',
          template_id:'',
          uploads:[],
        },
        templateId:[],
        params:{},//查询参数
        uploadUrl: UPLOAD_URL,
        ruleValidate: {
          name:[{
             required: true, message: '名称不能为空', trigger: 'blur' 
          }]
        },
        columns: [
          {
            title: '',
            key: 'id',
            render:(h,{ row,index })=>{
              return h('input',{
                attrs:{
                  name:'templateId',
                  type:'radio'
                },
                props:{
                  model:this.templateId[index]
                },
                on:{
                  click:(e)=>{
                    console.log(e.target.checked)
                    this.form.template_id = row.id
                  }
                },
              })
            }
          },
          {
            title: 'ID',
            key: 'id'
          },
          {
            title: "日期",
            key: "createTime"
          },
          {
            title: "名称",
            key: "name"
          },
         {
           title: "宽高",
           key: "width",
           render(h,params){
            return h('span',params.row.width + '*' + params.row.height)
           }
         },
          {
            title: "格式",
            key: "format"
          },
          {
            title: "视频codec",
            key: "videoCodec"
          },
          {
            title: "视频码率",
            key: "videoBitRate"
          },
          {
            title: "音频codec",
            key: "audioCodec"
          },
          {
            title: "音频码率",
            key: "audioBitRate"
          },
          {
            title: "大小",
            key: "fileSize",
            render(h, { row }) {
              return <span>{row.fileSize / 1024 / 1024}MB</span>;
            }
          },
        ]
      };
    },
    mounted() {
      this.fetch()
    },
    methods: {
      fetch() {
        this.$http.get(GET_TEMPLATE_LIST, {
          params: {
            page: this.currentPage,
            pageSize: this.pageSize,
            sortBy: "-vcs_template.id",
            ...this.params,
            status: 1,
            fileSize:this.params.fileSize*1024*1024 || undefined
          }
        })
          .then((response) => {
            const {code, data, errorMessage} = response.body;
            if (code === 0) {
              this.data = data.list
              this.total = data.totalCount
            } else {
              this.$Message.error(errorMessage)
            }
          })
      },
      submitForm(){
        this.$refs.formValidate.validate((valid) => {
            if (valid) {
              if(this.form.template_id){
                let requests = []
                _.filter([
                    ...this.form.urls,
                    ...this.form.uploads
                  ],f=>f.value)
                 .forEach((item)=>{
                  requests.push(this.$http.post(CREATE_TASK, {
                    input_url: item.value,
                    mode: 6, // 模式 3 扣图 6 格式化
                    name:this.form.name,
                    template_id: this.form.template_id
                  }))
                })
                Promise.all(requests).then((responses)=>{
                  console.log(responses)
                  let isSuccess = true
                  let errorMessage = ''
                  _.forEach(responses,r=>{
                    errorMessage = r.body.errorMessage
                    return isSuccess = r.body.code == 0
                  })
                  if(isSuccess){
                    this.$router.push('/transcoding/list')
                  }else{
                    this.$Message.error(errorMessage)
                  }
                  
                })
              }else{
                this.$Message.error('未选择模板')
              }
            }
        })
      },
      handleUploadSuccess(res, file){
        const url = file.response.data
        this.form.uploads.push({
          value: url,
          index: +new Date()
        })
      },
      handleUploadRemove(file){
        const url = file.response.data
        const position = _.findIndex(this.form.uploads, item=>item.value === url)
        if(position>=0){
          this.form.uploads.splice(position, 1);
        }
      },
      handleSelectTemplate(data){
        if(data.id){
          this.form.template_id = data.id
        }
      },
      handleRemoveUrl(index) {
        this.form.urls.splice(index, 1);
      },
      handleAddUrl() {
        this.form.urls.push({
          value: '',
          index: +new Date()
        })
      },
      getTask() {
//        this.$http.get(GET_TASK)
//          .then((response) => {
//            const {code, data, errorMessage} = response.body;
//            if (code === 0) {
//              this.data = data;
//            } else {
//              this.$Message.error(errorMessage)
//            }
//          })
      }
    },
    components: {}
  };
</script>
